module.exports = __webpack_public_path__ + "img/giphy.e9847c83.gif";